<!-- Header -->
<div class="flex items-center justify-between px-5 py-3 border-b border-gray-200">
  <div class="flex items-center gap-2">
    <h2 class="text-base font-semibold text-gray-900">{{ data.title }}</h2>
    <span *ngIf="getSelectedCount() > 0"
          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
      {{ getSelectedCount() }} ausgewählt
    </span>
  </div>
  <button mat-icon-button (click)="onCancel()" class="text-gray-400 hover:text-gray-600">
    <mat-icon class="w-4 h-4">close</mat-icon>
  </button>
</div>

<!-- Search -->
<div class="px-5 py-3 border-b border-gray-100">
  <div class="flex items-center gap-2 border border-gray-300 rounded-md px-3 py-2 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
    <mat-icon class="text-gray-400 flex-shrink-0" style="font-size: 18px; width: 18px; height: 18px;">search</mat-icon>
    <input
      [formControl]="searchControl"
      type="text"
      placeholder="Suchen..."
      class="w-full text-sm border-none outline-none bg-transparent">
  </div>
</div>

<!-- List -->
<div class="overflow-y-auto" style="max-height: 400px;">
  <div *ngFor="let item of filteredItems"
       class="flex items-center px-5 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
       (click)="!data.showAmounts && toggleSelection(item)">
    
    <!-- Checkbox -->
    <mat-checkbox
      [checked]="isSelected(item)"
      (change)="toggleSelection(item)"
      (click)="$event.stopPropagation()"
      class="mr-3">
    </mat-checkbox>

    <!-- Name & Description -->
    <div class="flex-1 min-w-0">
      <div class="text-sm font-medium text-gray-900">{{ item.name }}</div>
      <div *ngIf="item.description" class="text-xs text-gray-500 truncate">{{ item.description }}</div>
    </div>

    <!-- Amount Controls (only for Produkt) -->
    <div *ngIf="data.showAmounts" class="flex items-center gap-1 ml-3" (click)="$event.stopPropagation()">
      <button
        mat-icon-button
        class="w-8 h-8"
        style="width: 32px; height: 32px; line-height: 32px;"
        [disabled]="!isSelected(item)"
        (click)="decrementAmount(item, $event)">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">remove</mat-icon>
      </button>
      
      <input
        type="number"
        [value]="getAmount(item)"
        (change)="onAmountInput(item, $event)"
        (click)="$event.stopPropagation()"
        min="0"
        max="99"
        step="1"
        class="w-14 px-1 py-1 text-center text-sm font-semibold border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      
      <button
        mat-icon-button
        class="w-8 h-8"
        style="width: 32px; height: 32px; line-height: 32px;"
        (click)="incrementAmount(item, $event)">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">add</mat-icon>
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="filteredItems.length === 0" class="px-5 py-8 text-center text-gray-500 text-sm">
    Keine Einträge gefunden
  </div>
</div>

<!-- Footer -->
<div class="flex justify-end gap-3 px-5 py-3 border-t border-gray-200 bg-white">
  <button mat-button (click)="onCancel()" class="text-gray-600">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">
    OK
  </button>
</div>
